import React, { useState } from 'react';
import { X } from 'lucide-react';

const galleryImages = [
'https://customer-assets.emergentagent.com/job_4ebaa9cc-440b-4527-9761-4d4c07f094d6/artifacts/p1ky32z5_hero-couple.jpg',
'https://customer-assets.emergentagent.com/job_4ebaa9cc-440b-4527-9761-4d4c07f094d6/artifacts/tyvv1wls_Photo1F-.jpg',
'https://customer-assets.emergentagent.com/job_4ebaa9cc-440b-4527-9761-4d4c07f094d6/artifacts/30c6jkuv_Photo2F-.jpg',
'https://customer-assets.emergentagent.com/job_4ebaa9cc-440b-4527-9761-4d4c07f094d6/artifacts/4ozohe7c_Photo3F-.jpg',
'https://customer-assets.emergentagent.com/job_4ebaa9cc-440b-4527-9761-4d4c07f094d6/artifacts/mjjthn3i_Photo5F-.jpg',
'https://customer-assets.emergentagent.com/job_4ebaa9cc-440b-4527-9761-4d4c07f094d6/artifacts/kahlwzb7_Photo8F-.jpg'];


export const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const openLightbox = (index) => {
    setSelectedImage(index);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  const navigateImage = (direction) => {
    if (selectedImage === null) return;
    const newIndex = selectedImage + direction;
    if (newIndex >= 0 && newIndex < galleryImages.length) {
      setSelectedImage(newIndex);
    }
  };

  return (
    <div className="min-h-screen pt-20" data-testid="gallery-page">
      {/* Header */}
      <section className="py-16 md:py-20 px-6 md:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-display text-5xl md:text-7xl mb-6 animate-fade-in text-[#e17c3b]">Galerie</h1>
          <p className="text-[#8d5f3f]/70 text-lg max-w-2xl mx-auto animate-fade-in delay-100">Quelques moments précieux.

          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-8 px-6 md:px-12" data-testid="gallery-grid">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {galleryImages.map((image, index) =>
            <div
              key={index}
              className="aspect-square rounded-2xl overflow-hidden cursor-pointer group animate-slide-up relative shadow-md"
              style={{ animationDelay: `${index * 100}ms` }}
              onClick={() => openLightbox(index)}
              data-testid={`gallery-image-${index}`}>

                <img
                src={image}
                alt={`Photo ${index + 1}`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />

                <div className="absolute inset-0 bg-[#8d5f3f]/0 group-hover:bg-[#8d5f3f]/10 transition-colors duration-300" />
              </div>
            )}
          </div>
        </div>
      </section>

      {/* No bottom images for Gallery page */}

      {/* Lightbox */}
      {selectedImage !== null &&
      <div
        className="fixed inset-0 bg-black/95 z-[200] flex items-center justify-center"
        onClick={closeLightbox}
        data-testid="lightbox">

          {/* Close Button */}
          <button
          onClick={(e) => {e.stopPropagation();closeLightbox();}}
          className="absolute top-24 right-8 p-3 bg-white/10 hover:bg-white/20 rounded-full text-white/90 hover:text-white transition-colors z-[210]"
          data-testid="lightbox-close"
          aria-label="Fermer">

            <X size={28} />
          </button>

          {/* Navigation Arrows */}
          <button
          onClick={(e) => {e.stopPropagation();navigateImage(-1);}}
          disabled={selectedImage === 0}
          className="absolute left-6 top-1/2 -translate-y-1/2 p-4 text-white/80 hover:text-white disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
          data-testid="lightbox-prev"
          aria-label="Image précédente">

            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
          </button>
          
          <button
          onClick={(e) => {e.stopPropagation();navigateImage(1);}}
          disabled={selectedImage === galleryImages.length - 1}
          className="absolute right-6 top-1/2 -translate-y-1/2 p-4 text-white/80 hover:text-white disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
          data-testid="lightbox-next"
          aria-label="Image suivante">

            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </button>

          {/* Image */}
          <img
          src={galleryImages[selectedImage]}
          alt={`Photo ${selectedImage + 1}`}
          className="max-h-[90vh] max-w-[90vw] object-contain"
          onClick={(e) => e.stopPropagation()}
          data-testid="lightbox-image" />


          {/* Counter */}
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/80 text-sm">
            {selectedImage + 1} / {galleryImages.length}
          </div>
        </div>
      }
    </div>);

};